import { WidgetProps } from '@rjsf/utils';
import { Grid } from '@mui/material';
import { useAppSelector } from '@/redux/hooks';
import { selectSubtitlesLanguages } from '@/redux/selectors/constantsSelectors';
import Fieldset from '@/components/_common/Fieldset';
import LanguageSelector from '@/components/_common/LanguageSelector/LanguageSelector';
import SubtitleBox from '../SubtitleBox';

const SubtitleWidget = (props: WidgetProps) => {
  const { onChange, value } = props;
  const enumValues: string[] | undefined = props.schema?.items?.enum;
  const SubtitleLanguagesVals = useAppSelector(selectSubtitlesLanguages);
  const SubtitleLanguages = enumValues
    ? enumValues.map((val) => {
        const found = SubtitleLanguagesVals?.find((lang) => lang.code.replace('_', '-') === val);
        return found ? { code: val, label: found.label, is_short_list: found.is_short_list } : { code: val, label: val, is_short_list: true };
      })
    : SubtitleLanguagesVals;

  if (props.readonly) return <SubtitleBox value={value} />;

  return (
    <Grid container columnSpacing={5}>
      <Grid item sm={12}>
        <Fieldset label="Subtitle" color="default">
          <Grid container spacing={2} mt={0}>
            <Grid item sm={12}>
              <LanguageSelector color="default" languageCodes={value} languages={SubtitleLanguages} onChange={(codes) => onChange(codes)} />
            </Grid>
          </Grid>
        </Fieldset>
      </Grid>
    </Grid>
  );
};

export default SubtitleWidget;
